import { render, staticRenderFns } from "./TicketSidePanel.vue?vue&type=template&id=d8ab8f9a&"
import script from "./TicketSidePanel.vue?vue&type=script&lang=js&"
export * from "./TicketSidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8ab8f9a')) {
      api.createRecord('d8ab8f9a', component.options)
    } else {
      api.reload('d8ab8f9a', component.options)
    }
    module.hot.accept("./TicketSidePanel.vue?vue&type=template&id=d8ab8f9a&", function () {
      api.rerender('d8ab8f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/TicketSidePanel.vue"
export default component.exports